module.exports = __webpack_public_path__ + "img/12.ba81a050.jpg";